
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import {
  getPrinciplesScoresPrinciples
} from '../api';

import './styles.css';

import { navigation } from '../data';
import SubPagesLayout from '../../UI/layout/subPages';
import { LeaderboardOverall } from '../../UI/instructor/leaderboard/overall';

export default function DecisionInsightsPrinciples() {
  const navigate = useNavigate();

  const [filterBy, setFilterBy] = useState('Accuracy');
  const [data, setData] = useState(null);

  const filterByOptions = ['Accuracy', 'Points'];

  const { data: principlesScoresPrinciples } = useQuery({
      queryKey: ['principlesScoresPrinciples'],
      queryFn: async () => getPrinciplesScoresPrinciples(),
      refetchOnWindowFocus: false
    });

  useEffect(() => {
    if(principlesScoresPrinciples) {
      formatLeaderboardData();
    }
  }, [principlesScoresPrinciples, filterBy]);

  const calculateAverage = (data, param) => {
    if (!data || data.length === 0) return 0;

    let sum = 0;
    let count = 0;

    data.forEach(record => {
      const value = record[param];
      if (value !== null && value !== undefined) {
        sum += value;
        count++;
      }
    });

    return count > 0 ? sum / count : 0;
  };

  const formatLeaderboardData = () => {
    let wholeLeaderboardData = [];

    const revenueRecognitionPrincipleScores = principlesScoresPrinciples.filter(principlesScoresPrinciple => principlesScoresPrinciple.principle_name === 'Revenue Recognition');
    const revenueRecognitionScore = filterBy === 'Accuracy' ? calculateAverage(revenueRecognitionPrincipleScores, 'total_accuracy') : calculateAverage(revenueRecognitionPrincipleScores, 'total_points');
    const revenueRecognitionFormattedScore = filterBy === 'Accuracy' ? (revenueRecognitionScore * 100).toFixed(2) + '%' : revenueRecognitionScore;
    
    const expenseRecognitionPrincipleScores = principlesScoresPrinciples.filter(principlesScoresPrinciple => principlesScoresPrinciple.principle_name === 'Expense Recognition');
    const expenseRecognitionScore = filterBy === 'Accuracy' ? calculateAverage(expenseRecognitionPrincipleScores, 'total_accuracy') : calculateAverage(expenseRecognitionPrincipleScores, 'total_points');
    const expenseRecognitionFormattedScore = filterBy === 'Accuracy' ? (expenseRecognitionScore * 100).toFixed(2) + '%' : expenseRecognitionScore;

    wholeLeaderboardData = [
      {
        name: 'Revenue Recognition',
        score: revenueRecognitionScore,
        formattedScore: revenueRecognitionFormattedScore,
        backgroundColor: '#4C8AFF'
      },
      {
        name: 'Expense Recognition',
        score: expenseRecognitionScore,
        formattedScore: expenseRecognitionFormattedScore,
        backgroundColor: 'rgba(76, 138, 255, 0.5)'
      }
    ];

    setData(wholeLeaderboardData);
  }


  const handlePrevButtonClick = () => {
    navigate('/insights/decision-insights/double-entry/');
  }

  const handleFilterClick = (selectedFilterBy) => {
    setFilterBy(selectedFilterBy);
  }

  const maxScore = data ? data.reduce((max, item) => (item.score > max ? item.score : max), -Infinity) : 0;

  return (
    <SubPagesLayout
      navigation={navigation}
      onFirstButtonClick={handlePrevButtonClick}
      currentPage={1}
      pagesQuantity={1}
      contentClassName="decision-insights-content-container"
    >
      <h1>Insights | Overall</h1>
      <h2>The Principles</h2>
      <p>This chart, based on The Principles exercise data, showcases your grasp of revenue recognition and expense recognition principles.</p>
      <LeaderboardOverall
        title="Performance"
        data={data}
        filterBy={filterBy}
        filterByOptions={filterByOptions}
        onFilterByClick={handleFilterClick}
        maxScore={maxScore}
        isBigScores={true}
      />
      <p><span className="red"><b>Note:</b></span> The chart will continuously update until the deadline has passed on all assignments.</p>
    </SubPagesLayout>
  );
}
